import { render, staticRenderFns } from "./TimelineAsset.vue?vue&type=template&id=b4598870&scoped=true"
import script from "./TimelineAsset.vue?vue&type=script&lang=js"
export * from "./TimelineAsset.vue?vue&type=script&lang=js"
import style0 from "./TimelineAsset.vue?vue&type=style&index=0&id=b4598870&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4598870",
  null
  
)

export default component.exports